import React, {Component} from 'react';
import {Input,Form} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

class TaskDetail extends BaseComponent {
    constructor(props) {
        super(props);
        this.state={
            title: props.itemValue || "",
        }
    }
    componentDidMount() {
    }


    render() {
        return (
            <div id={'taskDetail'}>
                <Form.Item label={this.props.label} labelCol={{span: 3}}  style={{display:'flex'}}>
                    <div style={{marginTop:10,lineHeight: 1.5,wordBreak: 'break-word'}}>{this.props.itemValue}</div>
                    {/*<p style={{marginTop:10,lineHeight: 1.5}}>{this.props.itemValue}</p>*/}
                </Form.Item>
            </div>

        );
    }

}

export default TaskDetail